import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faEnvelope, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";

const AttendeeItem = ({ email, firstName, lastName, isSelected, index, toggleSelect }) => {
  return (
    <div className="attendee__item" data-index={index + 1} onClick={() => toggleSelect(index)}>
      <div className="attendee__check">
        <FontAwesomeIcon icon={isSelected ? faSquareCheck : faSquare} />
      </div>
      <div className="attendee__name" title={`${firstName} ${lastName}`}>
        {firstName} {lastName}
      </div>
      <div className="attendee__email" title={email}>
        {email}
      </div>
    </div>
  );
};

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const SendEvaluations = ({ attendees = [], eventId, event, refetchAttendees }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [shouldSelectAll, setShouldSelectAll] = useState(false);
  const [list, setList] = useState([]);
  const toastRef = useRef();
  const submitUpload = async () => {
    if (attendees.length === 0) return;
    if (!eventId) {
      toast.error("Event ID not found!");

      return;
    };
  };

  const handleSelect = (selectedIndex) => {
    setList((prev = []) => {
      return prev.map((item, index) => {
        if (index !== selectedIndex) return item;

        return {
          ...item,
          selected: !item.selected
        }
      });
    });
  };

  const handleSelectAll = () => {
    setShouldSelectAll((prev) => {
      setList((prevList) => {
        return prevList.map((item) => ({
          ...item,
          selected: !prev,
        }));
      });

      return !prev;
    });
  }

  const handleEvaluations = async () => {
    const selectedList = list.filter((item) => item.selected);
    console.log("Selected List", selectedList);

    if (selectedList.length === 0) return;
    setIsUploading(true);

    toastRef.current = toast.loading("Sending Evaluations");
    
    for (let i = 0; i < selectedList.length; i++) {
      try {
        const res = await fetch(`https://petros-global.com/ems/backend/evaluation/sendMail.php`, {
          cache: "no-store",
          headers: {
          "Authorization": "Ok"
          },
          method: "POST",
          body: JSON.stringify({
          variables: {
              eventDetails: {
                  name: event.name,
                  type: event.type,
                  eventRef: event.magic_link,
              },
              attendee: selectedList[i],
          },
          }),
      });
      } catch (err) {
        console.log("Error", err);
      }
      
      await timeout(2000);
    }

    toast.dismiss(toastRef.current);
    toast.success("Successfully sent Evaluations!");

    if (refetchAttendees) refetchAttendees();
    setShouldSelectAll(false);
    setIsUploading(false);
  };

  useEffect(() => {
    if (attendees.length > 0) setList(attendees.map((item) => ({...item, selected: false })));
  }, [attendees])

  return (
    <div className="upload__attendees">
      <div className="attendees__list">
        {list.length > 0 && (
          <div className="attendee__item" onClick={handleSelectAll}>
            <div className="attendee__check">
              <FontAwesomeIcon icon={shouldSelectAll ? faSquareCheck : faSquare} />
            </div>
            <div className="attendee_name">Select All</div>
          </div>
        )}
        {list.map((item, index) => (
          <AttendeeItem
            key={item.email + "-" + index}
            email={item.email}
            firstName={item.first_name}
            lastName={item.last_name}
            index={index}
            isSelected={item.selected}
            toggleSelect={handleSelect}
          />
        ))}
      </div>

      {!isUploading && (
        <div className="upload__btn">
          <button onClick={handleEvaluations}>Send Evaluations <FontAwesomeIcon icon={faEnvelope} /> </button>
        </div>
      )}
    </div>
  )
};

export default SendEvaluations;